/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './obstetric-event.reducer';

export const ObstetricEventDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const obstetricEventEntity = useAppSelector(state => state.obstetricEvent.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="obstetricEventDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.obstetricEvent.detail.title">ObstetricEvent</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.obstetricEvent.id">Id</Translate>
            </span>
          </dt>
          <dd>{obstetricEventEntity.id}</dd>
          <dt>
            <span id="pregnancyConfirmedDate">
              <Translate contentKey="tinyMedicRestApp.obstetricEvent.pregnancyConfirmedDate">Pregnancy Confirmed Date</Translate>
            </span>
          </dt>
          <dd>{obstetricEventEntity.pregnancyConfirmedDate}</dd>
          <dt>
            <span id="lengthOfPregnancy">
              <Translate contentKey="tinyMedicRestApp.obstetricEvent.lengthOfPregnancy">Length Of Pregnancy</Translate>
            </span>
          </dt>
          <dd>{obstetricEventEntity.lengthOfPregnancy}</dd>
          <dt>
            <span id="dandc">
              <Translate contentKey="tinyMedicRestApp.obstetricEvent.dandc">Dandc</Translate>
            </span>
          </dt>
          <dd>{obstetricEventEntity.dandc}</dd>
          <dt>
            <span id="childGender">
              <Translate contentKey="tinyMedicRestApp.obstetricEvent.childGender">Child Gender</Translate>
            </span>
          </dt>
          <dd>{obstetricEventEntity.childGender}</dd>
          <dt>
            <span id="childWeight">
              <Translate contentKey="tinyMedicRestApp.obstetricEvent.childWeight">Child Weight</Translate>
            </span>
          </dt>
          <dd>{obstetricEventEntity.childWeight}</dd>
          <dt>
            <span id="complications">
              <Translate contentKey="tinyMedicRestApp.obstetricEvent.complications">Complications</Translate>
            </span>
          </dt>
          <dd>{obstetricEventEntity.complications}</dd>
          <dt>
            <span id="deliveryType">
              <Translate contentKey="tinyMedicRestApp.obstetricEvent.deliveryType">Delivery Type</Translate>
            </span>
          </dt>
          <dd>{obstetricEventEntity.deliveryType}</dd>
          <dt>
            <span id="eventType">
              <Translate contentKey="tinyMedicRestApp.obstetricEvent.eventType">Event Type</Translate>
            </span>
          </dt>
          <dd>{obstetricEventEntity.eventType}</dd>
          <dt>
            <span id="labourStartDate">
              <Translate contentKey="tinyMedicRestApp.obstetricEvent.labourStartDate">Labour Start Date</Translate>
            </span>
          </dt>
          <dd>{obstetricEventEntity.labourStartDate}</dd>
          <dt>
            <span id="lenghtOfLabor">
              <Translate contentKey="tinyMedicRestApp.obstetricEvent.lenghtOfLabor">Lenght Of Labor</Translate>
            </span>
          </dt>
          <dd>{obstetricEventEntity.lenghtOfLabor}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.obstetricEvent.active">Active</Translate>
            </span>
          </dt>
          <dd>{obstetricEventEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="draft">
              <Translate contentKey="tinyMedicRestApp.obstetricEvent.draft">Draft</Translate>
            </span>
          </dt>
          <dd>{obstetricEventEntity.draft ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.obstetricEvent.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{obstetricEventEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.obstetricEvent.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{obstetricEventEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.obstetricEvent.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{obstetricEventEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.obstetricEvent.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{obstetricEventEntity.timestampEntry}</dd>
          <dt>
            <span id="expose">
              <Translate contentKey="tinyMedicRestApp.obstetricEvent.expose">Expose</Translate>
            </span>
          </dt>
          <dd>{obstetricEventEntity.expose ? 'true' : 'false'}</dd>
          <dt>
            <span id="consentTaken">
              <Translate contentKey="tinyMedicRestApp.obstetricEvent.consentTaken">Consent Taken</Translate>
            </span>
          </dt>
          <dd>{obstetricEventEntity.consentTaken ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.obstetricEvent.patient">Patient</Translate>
          </dt>
          <dd>{obstetricEventEntity.patient ? obstetricEventEntity.patient.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.obstetricEvent.pregnancy">Pregnancy</Translate>
          </dt>
          <dd>{obstetricEventEntity.pregnancy ? obstetricEventEntity.pregnancy.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/obstetric-event" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/obstetric-event/${obstetricEventEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ObstetricEventDetail;
